import { render, staticRenderFns } from "./HotelhandleMatch.vue?vue&type=template&id=86f88a6a&scoped=true"
import script from "./HotelhandleMatch.vue?vue&type=script&lang=js"
export * from "./HotelhandleMatch.vue?vue&type=script&lang=js"
import style0 from "./HotelhandleMatch.vue?vue&type=style&index=0&id=86f88a6a&prod&scoped=true&lang=less"
import style1 from "./HotelhandleMatch.vue?vue&type=style&index=1&id=86f88a6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f88a6a",
  null
  
)

export default component.exports